/**
 * Whether a character may choose to flag (ADR-076's amendment of 2026-10-08, C1): its level has reached the rules'
 * `pvp_level`. The map server decides with it; the page only draws with it.
 *
 * @param level The character's level.
 * @param pvpLevel The rules' `pvp_level`.
 * @returns True from `pvpLevel` up.
 */
export function pvpUnlocked(level: number, pvpLevel: number): boolean {
  return level >= pvpLevel;
}
